// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React, { useEffect, useRef, useState } from 'react';

import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Form from '@cloudscape-design/components/form';
import FormField from '@cloudscape-design/components/form-field';
import Header from '@cloudscape-design/components/header';
import Hotspot from '@cloudscape-design/components/hotspot';
import Input, { InputProps } from '@cloudscape-design/components/input';
import Link from '@cloudscape-design/components/link';


import SpaceBetween from '@cloudscape-design/components/space-between';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Flashbar, { FlashbarProps } from '@cloudscape-design/components/flashbar';
import { useGlobalState } from '../../../context/GlobalStateContext'
import { Box, Checkbox, Modal, RadioGroup, TextContent } from '@cloudscape-design/components';
import { getParameter, isValidPhone } from '../../../commons/functions'; // Import the function
import { mdiFormatVerticalAlignBottom, mdiLogin } from '@mdi/js';
import { RiLoginBoxLine } from "react-icons/ri";
import Icon from '@mdi/react';

export const UserLoginPage = () => {
  const { idPropiedad, setIdPropiedad } = useGlobalState();
  const { propiedad, setPropiedad } = useGlobalState();
  const { movil, setMovil } = useGlobalState();
  const { idControl, setIdControl } = useGlobalState();
  const { displayName, setDisplayName } = useGlobalState();
  const { JWT, setJWT } = useGlobalState();
  const { setLoading } = useGlobalState();

  const [inputMovil, setInputMovil] = useState('');
  const [inputPassword, setInputPassword] = useState(''); //Arl3quin$$
  const [infoRestoreCode, setInfoRestoreCode] = useState('');
  const [infoRestoreCodePwd1, setInfoRestoreCodePwd1] = useState('');
  const [infoRestoreCodePwd2, setInfoRestoreCodePwd2] = useState('');
  const { gData, setGData } = useGlobalState();
  const { menu, setMenu } = useGlobalState();

  const [showPassword, setShowPassword] = useState(false);
  const [revealPassword, setRevealPassword] = useState(false);
  const [passWordType, setPassWordType] = useState('password');
  const [init, setInit] = useState(false);
  const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);
  const [messagesModal, setMessagesModal] = useState<FlashbarProps.MessageDefinition[]>([]);
  const [isDisabledMovil, setIsDisabledMovil] = useState(false);
  const inputRefMovil = useRef<HTMLInputElement>(null);
  const inputRefPwd = useRef<HTMLInputElement>(null);
  const [isDisabledBtnNext, setIsDisabledBtnNext] = useState(true);
  const [recoveryMethod, setRecoveryMethod] = useState('');
  const [showModalStep1, setShowModalStep1] = useState(true);
  const [showModalStep2, setShowModalStep2] = useState(false);

  const [isResetModalOpen, setIsResetModalOpen] = useState(false); // State for the reset password modal
  const [isDisabledCodeType, setIsDisabledCodeType] = useState(true); // State for the reset password modal

  /*
    const onJobNameChangePhone = (event: any) => {
      setJobName(event.detail.value);
      setMessages([]);
    };
    */
  const handleInfoRestoreCode: InputProps["onChange"] = (event) => {
    setInfoRestoreCode(event.detail.value);
  };
  const handleInfoRestoreCodePwd1: InputProps["onChange"] = (event) => {
    setInfoRestoreCodePwd1(event.detail.value);
  };
  const handleInfoRestoreCodePwd2: InputProps["onChange"] = (event) => {
    setInfoRestoreCodePwd2(event.detail.value);
  };

  const handleNumericInputChange: InputProps["onChange"] = (event) => {
    const digitsOnly = event.detail.value.replace(/\D/g, '');
    setInputMovil(digitsOnly);
    setMessages([]);
    setIsDisabledBtnNext(!isValidPhone(digitsOnly)); // Initially disable the button

  };
  const handlePasswordChange: InputProps["onChange"] = (event) => {
    setInputPassword(event.detail.value);
    setMessages([]);
  };
  const { returnUrl, setReturnUrl } = useGlobalState();
  const [shouldRedirect, setShouldRedirect] = useState(false);
  useEffect(() => {
    let rUrl = (getParameter(window.location.hash, "returnUrl"))
    if (shouldRedirect && JWT) {
      console.log("returnUrl Login2:" + rUrl + " " + idPropiedad)
      if (idPropiedad) {
        if (rUrl != '') {
          window.location.hash = '#' + rUrl;
          console.log("Go->rURL")
        } else if (idPropiedad === 0) {
          window.location.hash = '#admin/properties';
          console.log("Go->Properties")
        } else {
          window.location.hash = '#home';
          console.log("Go->HOME")
        }


        return;
      }
    }

  }, [shouldRedirect]);
  useEffect(() => {
    //setPropiedad("");
    //setIdPropiedad(0);
  }, [init]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setInputMovil(movil)
      setInputPassword('')
      setIsDisabledBtnNext(!isValidPhone(movil))
      if (inputRefMovil.current) {
        inputRefMovil.current.focus();
      }
    }, 500); // 2000 milliseconds = 2 seconds

    // Cleanup if component unmounts
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!showModalStep1) {
      // Code to execute after the modal is hidden (if needed)
      console.log("Modal Step 1 is now hidden");
      setLoading(false)
    }
    if (!showModalStep2) {
      // Code to execute after the modal is hidden (if needed)
      console.log("Modal Step 1 is now hidden");
      setLoading(false)
    }
  }, [showModalStep1, showModalStep2]);
  const handleCloseSendResetModal = async () => { // Make the function async
    setPendingJobCreation(true);
    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/public/admin/login/reset.password',
        },
        body: JSON.stringify({
          movil: inputMovil,
          recoveryMethod: recoveryMethod,
        }),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
        setIsDisabledMovil(false);
      }
      const data = await response.json();
      if (data.code == 0) {
        //setIsResetModalOpen(false); // Update the modal visibility state

        setShowModalStep1(false);
        setShowModalStep2(true);

        setMessagesModal([
          {
            type: 'success',
            content: data.status,
            id: 'server-success',
          },
        ]);

      }
    } catch (error: any) {
      setMessagesModal([
        {
          type: 'error',
          content: `Error al contactar el servidor: ${error.message}`,
          id: 'server-error',
        },
      ]);
    } finally {
      setPendingJobCreation(false);
      setLoading(true)
    }
  };

  const handleResetPassword = () => {
    setIsResetModalOpen(true); // Update the modal visibility state
    setIsDisabledCodeType(true)
    setRecoveryMethod('');
    setShowModalStep1(true)
    setShowModalStep2(false)
    setMessagesModal([])

  };

  const handleCloseResetModal = () => {
    setIsResetModalOpen(false); // Update the modal visibility state
  };
  const handleCloseSendRestoreModal = async () => {
    console.log("restore")
    if (infoRestoreCode.length !== 6) {

      setMessagesModal([
        {
          type: 'error',
          content: 'Código de restauración debe ser de 6 dígitos',
          id: 'server-error',
        },
      ]);
      return
    }
    if (infoRestoreCodePwd1.length < 7) {

      setMessagesModal([
        {
          type: 'error',
          content: 'Contraseña debe ser de al menos 8 caracteres',
          id: 'server-error',
        },
      ]);
      return
    }
    if (infoRestoreCodePwd1 !== infoRestoreCodePwd2) {

      setMessagesModal([
        {
          type: 'error',
          content: 'Contraseña y confirmación no son iguales',
          id: 'server-error',
        },
      ]);
      return
    }
    setMessagesModal([])

    setPendingJobCreation(true);
    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/public/admin/login/restore.password',
        },
        body: JSON.stringify({
          movil: inputMovil,
          adminTempPassword: infoRestoreCode,
          adminTempNewPassword: infoRestoreCodePwd1,
        }),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
        setIsDisabledMovil(false);
      }
      const data = await response.json();
      if (data.code == 0) {
        setIsResetModalOpen(false); // Update the modal visibility state
        window.location.href = '#user/login';
        setMessagesModal([])
        setMessages([
          {
            type: 'success',
            content: `${data.status}`,
            id: 'server-error',
          },
        ]);
      } else {
        setMessagesModal([
          {
            type: 'error',
            content: `Error:${data.status}`,
            id: 'server-error',
          },
        ]);

      }
    } catch (error: any) {
      setMessagesModal([
        {
          type: 'error',
          content: `Error al contactar el servidor: ${error.message}`,
          id: 'server-error',
        },
      ]);
    } finally {
      setPendingJobCreation(false);
      setLoading(false)
    }
  }
  const handleValidatePasword = async () => {


    setPendingJobCreation(true);
    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/public/admin/login/step2',
          // 
        },
        body: JSON.stringify({
          movil: inputMovil,
          password: inputPassword,
        }),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
        setIsDisabledMovil(false);
      }
      const data = await response.json();
      if (data.code == 0) {
        setIdPropiedad(data.idPropiedad);
        setPropiedad(data.propiedad);
        setIdControl(data.idControl);
        setDisplayName(data.displayName);
        setJWT(data.JWTRenew);
        console.log("idPropiedad:", data.idPropiedad);
        //LOAD INIT INFO
        try {
          setLoading(true)
          const response2 = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-routing': '/users/user/login',
              'JWT': data.JWTRenew,
            },
            body: JSON.stringify({
              idPropiedadAdmin: data.idPropiedad,
              units: true,
              users: false,
            })
          });

          if (!response2.ok) { throw new Error(`HTTP error: ${response2.status}`); }
          const data2 = await response2.json();
          if (!data2.JWT) { }
          //saveJWT(data)
          // Assuming the counters are available in data.admin.counters
          if (data2.admin) { setGData(data2.admin); }
          if (data2.admin.menu) { setMenu(data2.admin.menu); console.log(data2.admin.menu) }
          //setShouldRedirect(true);
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setLoading(false)
          setPendingJobCreation(false);
        }
        setShouldRedirect(true);

      } else {
        setInputPassword('')
        setMessages([
          {
            type: 'error',
            content: data.status,
            id: 'server-error',
          },
        ]);
      }
    } catch (error: any) {
      setMessages([
        {
          type: 'error',
          content: `Error al contactar el servidor: ${error.message}`,
          id: 'server-error',
        },
      ]);
    } finally {
      setPendingJobCreation(false);
      setLoading(false)
    }
  }

  useEffect(() => {
    if (showPassword) {
      if (inputRefPwd.current) {
        inputRefPwd.current.focus();
      }
    }
  }, [showPassword]);
  setTimeout(function () {
    setInit(true);
  }, 0);
  const handleValidatePhone = async () => {
    const regex = /^\+?56\d{9}$/;
    if (!regex.test(inputMovil)) {
      setMessages([
        {
          type: 'error',
          content: 'Número inválido. Use formato +56912345678 o 56912345678',
          id: 'error-msg',
        },
      ]);
      return
    }
    setPendingJobCreation(true);
    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/public/admin/login/step1',
          //  
        },
        body: JSON.stringify({
          movil: inputMovil,
        }),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
        setIsDisabledMovil(false);
      }
      const data = await response.json();
      if (data.code == 0) {
        setIsDisabledMovil(true);
        setShowPassword(true)
        setMovil(inputMovil)


      } else {
        setMessages([
          {
            type: 'error',
            content: data.status,
            id: 'server-error',
          },
        ]);
      }
    } catch (error: any) {
      setMessages([
        {
          type: 'error',
          content: `Error al contactar el servidor: ${error.message}`,
          id: 'server-error',
        },
      ]);
    } finally {
      setPendingJobCreation(false);
      setLoading(false)
    }
  };

  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();
  const [pendingJobCreation, setPendingJobCreation] = useState(false);
  const createJob = () => {
    //setPendingJobCreation(true);
    //setTimeout(() => navigate('transcription-job-list'), 1000);
  };

  const handleBtnBack = () => {
    setIsDisabledMovil(false);
    setInputPassword('');
    setInputMovil('');
    setIsDisabledBtnNext(!isValidPhone(''))
    setShowPassword(false)
  };
  //{{ display: 'flex', alignItems: 'flex-end', height: '100px' }}
  return (
    <>
      <CustomAppLayout
        toolsHide={true}
        contentType="form"
        content={
          <form onSubmit={event => event.preventDefault()}>
            <Form
              header={
                <Header variant="h1">
                  Iniciar Sesión
                  <Icon path={mdiLogin} size={1} />
                  {/* <RiLoginBoxLine /> */}

                </Header>
              }
            >
              <SpaceBetween size="xl">
                <Container header={<Header>Identificación del usuario</Header>}>
                  <SpaceBetween size="l">
                    <Flashbar items={messages} />
                    <FormField
                      label="Número de móvil"
                      constraintText="El número de móvil debe ser en formato internacional (Ej: +56912345678).">
                      <Hotspot hotspotId="transcription-job-name">
                        <SpaceBetween direction="horizontal" size="xs">
                          <Input
                            controlId='infoMovil'
                            value={inputMovil}
                            placeholder="56912354678"
                            disabled={isDisabledMovil}
                            onChange={handleNumericInputChange}
                            ref={inputRefMovil}
                            autoComplete=""
                          />
                          {!showPassword && (
                            <Button onClick={handleValidatePhone} disabled={isDisabledBtnNext} variant="primary" loading={pendingJobCreation} >Siguiente</Button>
                          )}
                        </SpaceBetween>
                      </Hotspot>
                    </FormField>

                    {showPassword && (
                      <>
                        <FormField label="Contraseña"
                          info={
                            (<Link variant="info" onClick={handleBtnBack}>Atrás</Link>)
                          }
                        >
                          <Hotspot hotspotId="transcription-job-name">
                            <SpaceBetween direction="horizontal" size="xs">
                              <Input
                                controlId='infoPassword'
                                value={inputPassword}
                                type={passWordType as InputProps.Type}
                                onChange={handlePasswordChange}
                                ref={inputRefPwd}
                                autoComplete="new-password"
                              />
                              <Button onClick={handleValidatePasword} variant="primary" loading={pendingJobCreation} >Validar</Button>
                            </SpaceBetween>
                          </Hotspot>
                        </FormField>
                        <SpaceBetween direction="horizontal" size="xs">
                          <div style={{ transform: 'scale(0.8)', transformOrigin: 'top left' }}>
                            <Box textAlign='left'>
                            <Checkbox
                              onChange={(event) => {
                                setRevealPassword(event.detail.checked)
                                passWordType=='password' ? setPassWordType('text') : setPassWordType('password');
                              }}
                              checked={revealPassword}
                            >
                              Mostrar
                            </Checkbox>
                            </Box>
                          </div>
                          <Box textAlign="right">
                          <Link variant="info" onClick={handleResetPassword}>Restaurar</Link>
                          </Box>
                        </SpaceBetween>
                      </>
                    )}
                  </SpaceBetween>

                </Container>
              </SpaceBetween>

            </Form>
          </form>
        }
      />
      <Modal
        visible={isResetModalOpen}
        onDismiss={handleCloseResetModal}
        header="Restaurar contraseña"
        size='small'
        footer={
          <div>

            <Box display={showModalStep1 ? 'block' : 'none'}>
              <Button variant="primary" disabled={isDisabledCodeType}
                loading={pendingJobCreation}
                onClick={() => { /* Handle reset logic */ handleCloseSendResetModal(); }}>
                Enviar código
              </Button>
              <Button onClick={handleCloseResetModal} variant="link">
                Cancelar
              </Button>
            </Box>

            <Box display={showModalStep2 ? 'block' : 'none'}>
              <Button variant="primary" disabled={isDisabledCodeType}
                loading={pendingJobCreation}
                onClick={() => { /* Handle reset logic */ handleCloseSendRestoreModal(); }}>
                Restaurar
              </Button>
              <Button onClick={handleCloseResetModal} variant="link">
                Cancelar
              </Button>
            </Box>

          </div>
        }
      >
        <SpaceBetween size='xs'>
          <Flashbar items={messagesModal} />
          <Box display={showModalStep1 ? 'block' : 'none'}>
            <p>¿Está seguro que desea <strong>restaurar su contraseña</strong>?. Se enviará un código temporal para restablecer su restablecimiento</p>
            <p>Seleccione como desea recibirlo:</p>
            <RadioGroup
              onChange={({ detail }) => { setRecoveryMethod(detail.value); setIsDisabledCodeType(false) }}
              value={recoveryMethod}
              items={[
                { value: "EMAIL", label: "Email" },
                { value: "SMS", label: "SMS" },
                { value: "WHATSAPP", label: "WhatsApp" }
              ]}
            />
          </Box>
          <Box display={showModalStep2 ? 'block' : 'none'}>
            <Form>
              <FormField label="Código de autorización">
                <Input
                  controlId='infoRestoreCode'
                  value={infoRestoreCode}
                  autoComplete="new-password"
                  onChange={handleInfoRestoreCode}
                />
              </FormField>

              <FormField label="Contraseña">
                <Input
                  controlId='infoRestoreCodePwd1'
                  value={infoRestoreCodePwd1}
                  type='password'
                  autoComplete="new-password"
                  onChange={handleInfoRestoreCodePwd1}
                />
              </FormField>

              <FormField label="Confirmación">
                <Input
                  controlId='infoRestoreCodePwd2'
                  value={infoRestoreCodePwd2}
                  type='password'
                  autoComplete="new-password"
                  onChange={handleInfoRestoreCodePwd2}
                />
              </FormField>
            </Form>
          </Box>
        </SpaceBetween>
      </Modal>
    </>
  );
};
